import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAsset11 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 8.75H0.75V14.75H6.75V8.75Z",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.75 8.75H8.75V14.75H14.75V8.75Z",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 0.75H0.75V6.75H6.75V0.75Z",
			stroke: "#212121",
			strokeWidth: 1.5,
			strokeLinejoin: "bevel"
		})
	]
});
export default SvgAsset11;
